import { Box } from '@factorialco/deprecated-design-system'

import Card from 'modules/attendance/components/CustomTimeRanges/Content/TimeCategoriesValues/Card'
import { CustomTimeRangeCategory } from 'modules/attendance/hooks/useFetchCustomTimeRangeCategories'

interface Props {
  activeCustomTimeRangeCategories: CustomTimeRangeCategory[]
}

const ActiveCategoriesSection = ({ activeCustomTimeRangeCategories }: Props) => {
  if (activeCustomTimeRangeCategories.length === 0) {
    return null
  }

  return (
    <Box gap="s8">
      {activeCustomTimeRangeCategories.map((category) => (
        <Card key={category.id} category={category} />
      ))}
    </Box>
  )
}

export default ActiveCategoriesSection
